import React from 'react';

const setHTML = html => /*#__PURE__*/React.createElement("span", {
  dangerouslySetInnerHTML: {
    __html: html
  }
});

export default setHTML;